import React from 'react';
import {DownOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import {Badge, Dropdown, Space, Table, Tag, Tooltip} from 'antd';


const ColumnsFields = [
  {
    align: 'left',
    title: <div style={{textAlign: 'center'}}>

 <span>
      客户名称
        <Tooltip
          title={'包含渠道和直签客户'}
        >
    <QuestionCircleOutlined/>
  </Tooltip>
    </span></div>,
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    useSearch:true,
    render: (text, value) => <a onClick={() => {
    }}>{text}</a>,
  },
  {
    title: <div style={{textAlign: 'center'}}>税号</div>,
    align: 'left',
    dataIndex: 'taxId',
    useSearch:true,
    key: 'taxId',
  },
  {
    title: '是否为渠道商',
    dataIndex: 'isChannelMerchants',
    align: 'center',
    key: 'isChannelMerchants',
    render: (tags, record) => (
      <>
        {
          <Tag color={record.isChannelMerchants === '是' ? 'green' : 'red'
          } key={tags}>
            {record.isChannelMerchants}
          </Tag>}
      </>
    )
  },
  {
    title: <span>
  关联渠道商
      <Tooltip
        title={'这是哪一个渠道下的客户'}
      >
    <QuestionCircleOutlined/>
    </Tooltip>
</span>,
    dataIndex: 'channelMerchants',
    align: 'center',
    useSearch:true,
    key: 'channelMerchants',
  },
  {
    title: '客户经理',
    dataIndex: 'cusManage',
    align: 'center',
    key: 'cusManage',
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    align: 'center',
    key: 'updateTime',
  },
  // {
  //   title: 'Status',
  //   key: 'state',
  //   render: () => <Badge status="success" text="Finished" />,
  // },
];

export default ColumnsFields;
